import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { EMPTY } from 'rxjs';

import { NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_INFO } from 'ui-components/services/notification-service';

import { DocumentType } from '../../../enums/document-type';

const messages = defineMessages({
  printingUomBarcodeTitle: {
    description: 'Notification title when generating UoM barcodes',
    defaultMessage: 'Printing UoM Barcodes...',
    id: 'kjL0Lu',
  },
  downloadUomBarcodeStartedContent: {
    description: 'Notification message shown when UoM barcode download starts',
    defaultMessage: 'UoM Barcodes download started.',
    id: '/wyYec',
  },
  downloadUomBarcodeCompletedContent: {
    description: 'Notification message shown when UoM barcode download completes',
    defaultMessage: 'UoM Barcodes download completed.',
    id: '7eAcZh',
  },
  printUomBarcodeSuccessContent: {
    description: 'Notification message shown when UoM barcodes are sent to printer',
    defaultMessage: 'UoM Barcodes sent to printer.',
    id: '8PWdRS',
  },
  asyncPrintUomBarcodeStartedContent: {
    description: 'Notification message shown when generating UoM barcodes',
    defaultMessage: 'We are generating your UoM Barcodes.',
    id: 'kDOj5H',
  },
  asyncPrintUomBarcodeFailedContent: {
    description: 'Notification message shown when generating UoM barcodes fails',
    defaultMessage: 'Failed to generate UoM Barcodes. Please try again.',
    id: 'YGvqwO',
  },
});

export const uomBarcode = {
  id: DocumentType.UomBarcode.identifier,

  getDownloadStartedProps: () => ({
    title: <FormattedMessage {...messages.printingUomBarcodeTitle} />,
    content: <FormattedMessage {...messages.downloadUomBarcodeStartedContent} />,
  }),

  getDownloadCompletedProps: () => ({
    title: <FormattedMessage {...messages.printingUomBarcodeTitle} />,
    content: <FormattedMessage {...messages.downloadUomBarcodeCompletedContent} />,
  }),

  getPrintedSuccessNotificationProps: () => ({
    title: <FormattedMessage {...messages.printingUomBarcodeTitle} />,
    content: <FormattedMessage {...messages.printUomBarcodeSuccessContent} />,
  }),

  getAsyncPrintStartedNotificationProps: () => ({
    title: <FormattedMessage {...messages.printingUomBarcodeTitle} />,
    content: <FormattedMessage {...messages.asyncPrintUomBarcodeStartedContent} />,
    notificationType: NOTIFICATION_TYPE_INFO,
  }),

  getAsyncPrintFailedNotificationProps: () => ({
    title: <FormattedMessage {...messages.printingUomBarcodeTitle} />,
    content: <FormattedMessage {...messages.asyncPrintUomBarcodeFailedContent} />,
    notificationType: NOTIFICATION_TYPE_ERROR,
    duration: NOTIFICATION_DURATIONS.MEDIUM,
  }),

  getPrintedSuccessObservable: () => EMPTY,
};
